module.exports = __webpack_public_path__ + "static/media/orange-white.b92008e0.png";